export default __webpack_public_path__ + "static/media/laundry.41f86ed8.jpg";